/**
 * Password utilities
 */

const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const DIGITS = '0123456789';
const SPECIAL = '!@#$%^&*';
const CHARSET = LOWER + UPPER + DIGITS + SPECIAL;
const LENGTH = 16;

/** Uniform integer in [0, max), max ≤ 256: bytes past the last whole multiple are rejected. */
const randomBelow = (max) => {
  const limit = 256 - (256 % max);
  const byte = new Uint8Array(1);
  do crypto.getRandomValues(byte);
  while (byte[0] >= limit);
  return byte[0] % max;
};

const pick = (chars) => chars[randomBelow(chars.length)];

/**
 * Generate a secure random password
 * @returns {string} 16-character password, one character of each class at least
 */
export const generateRandomPassword = () => {
  const chars = [pick(UPPER), pick(LOWER), pick(DIGITS), pick(SPECIAL)];
  while (chars.length < LENGTH) chars.push(pick(CHARSET));
  // Fisher–Yates, so the forced characters do not stay in front.
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = randomBelow(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
};
